<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img key="onlineImg" :src="profileImage" alt="user-img" width="40" height="40" class="cursor-pointer block" style="border-radius: 50%;" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <vs-divider class="m-1" />
        
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/login').catch(() => {})">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('Logout')}}</span>
          </li>
      
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    profileImage(){
      return this.$store.state.AppActiveUser.photoURL;
    }
  },
  methods: {
    logout() {
        this.$router.push('/login').catch(() => {})       

        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change('public')
        localStorage.removeItem('userInfo')
    },
  }
}
</script>